import { HttpService } from "../../modules/shared/services/http.service";
import { Milestone, MilestoneCreateDto } from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

export const createMilestone = async (data: MilestoneCreateDto): Promise<Milestone> => {
	const response = await HttpService.post("api/v1/milestones", data, headers, true);
	return response;
};

export const updateMilestone = async (id: string, data: Partial<MilestoneCreateDto>): Promise<Milestone> => {
	const response = await HttpService.patch(`api/v1/milestones/${id}`, data, headers, true);
	return response;
};

export const getMilestoneById = async (id: string): Promise<Milestone> => {
	const response = await HttpService.get(`api/v1/milestones/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getMilestones = async (query?: Record<string, string | number | boolean>): Promise<{ data: Milestone[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/milestones${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteMilestone = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/milestones/${id}`, { "x-custom-lang": "en" }, true);
};

export const getMilestonesByContract = async (query?: Record<string, string | number | boolean>): Promise<{ data: Milestone[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/milestones/by-contract${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};


